<template>
  <div>
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
      <template #start>
        <el-form-item class="startBtn">
          <el-button type="primary" @click="addItem" icon="el-icon-plus">添加</el-button>
        </el-form-item>
      </template>
    </SearchField>
    <Table ref="table" :tableHeight="tableHeight" :tableData="tableData" :cols="cols" :btns="btns" :page="page" :limit="limit" :total="total" :showIndex="true"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";
import staffTableMixin from "../mixin/table";

export default {
  name: "StaffVehicleService",
  mixins: [tableMixin, staffTableMixin],
  data() {
    return {
      formInline: {
        user_group_id: 7,
        iswork: 1,
      },
      btns: [
        {
          ...this.viewBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/${this.baseUrl}/vehicleServiceDetail?mode=view&id=${id}`
            );
          },
        },
        {
          ...this.editBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/${this.baseUrl}/vehicleServiceDetail?mode=edit&id=${id}`
            );
          },
        },
        {
          ...this.delBtn,
          cb: ({ id }) => {
            this.delete(id);
          },
        },
      ],
    };
  },
  methods: {
    addItem() {
      this.$router.push(`/${this.baseUrl}/vehicleServiceDetail`);
    },
  },
};
</script>
